import React, { useEffect, useState } from "react";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";

export const OfflineBanner = () => {
    const isOnline = useNetworkStatus();
    const [visible, setVisible] = useState(false);
    const [wasOffline, setWasOffline] = useState(false);
    useEffect(() => {
        if (!isOnline) {
            setVisible(true);
            setWasOffline(true);
        } else if (wasOffline) {
            // Mostrar brevemente el mensaje de reconexión y luego ocultar
            setTimeout(() => {
                setVisible(false);
                setWasOffline(false);
            }, 3000);
        }
    }, [isOnline, wasOffline]);

    if (!visible) return null;

    return (
        <div style={isOnline ? styles.bannerOnline : styles.bannerOffline}>
            <span style={styles.dot(isOnline)} />
            {isOnline
                ? "Conexión activa"
                : "Sin conexión a internet. Verificá tu red."}
        </div>
    );
};

const styles = {
    bannerOffline: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#1a1a2e",
        color: "#ff6b6b",
        padding: "10px 20px",
        textAlign: "center",
        fontFamily: "Nunito Sans, sans-serif",
        fontWeight: 600,
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        animation: "slideDown 0.3s ease",
    },
    bannerOnline: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#1a1a2e",
        color: "#6bffb8",
        padding: "10px 20px",
        textAlign: "center",
        fontFamily: "Nunito Sans, sans-serif",
        fontWeight: 600,
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    },
    dot: (isOnline) => ({
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: isOnline ? "#6bffb8" : "#ff6b6b",
        display: "inline-block",
        flexShrink: 0,
    }),
};